import DiscountToolRepository from '../../repositories/DiscountToolRepository';
import Table from '../../components/table/Table';
import TableElements from '../../components/table/TableElements';
import tableProps from './json/tableProps.json';
import eventListenerProps from './json/eventListenerProps.json';

export default class DiscountToolService {
    /**
     * @property {Object} DiscountToolService Save data methods
     * @property {Object} Table helper class
     * @property {Object} tableElements helper class
     * @property {Object} DiscountToolRepository repository class
     * @property {Object} eventListenerProps json object with properties
     * @property {Object} tableProps json object with properties
     * @returns void
     */
    constructor() {
        this.repository = new DiscountToolRepository();
        this.table = new Table();
        this.tableElements = new TableElements();
        this.eventProps = eventListenerProps;
        this.tableProps = tableProps;

        this.saveAllDataEventHandler = {};
        this.saveDataEventHandler = {};

        this.initSaveAllEvents();
    }

    /**
     * @description Initialize event listeners on save buttons
     * @returns void
     */
    initSaveAllEvents() {
        this.saveAllDataEventHandler = this.prepareSaveAllInputs.bind(this);
        document.querySelector('#saveAll').addEventListener('click', this.saveAllDataEventHandler);
    }

    /**
     * @description Eventlistener for save
     * @param {Object} item event item from observer
     * @returns if observed class is set || void
     */
    addSaveEventListener(item) {
        this.saveDataEventHandler = this.prepareSaveInput.bind(this);

        if (item.parentNode.classList.contains('editable')) {
            if (item.parentNode.querySelector('.saveInput').classList.contains('observed')) {
                return;
            }

            let id = item.parentNode.querySelector('.saveInput').getAttribute('id');
            item.parentNode
                .querySelector(`#${id}`)
                .addEventListener('click', this.saveDataEventHandler);

            if (!item.parentNode.querySelector('.saveInput').classList.contains('observed')) {
                item.parentNode.querySelector('.saveInput').classList.add('observed');
            }
        }
    }

    /**
     * @description Save data for all inputs
     * @param {Object} evt event
     * @returns void
     */
    prepareSaveAllInputs = async (evt) => {
        let id, value;
        let saveObject = [];

        this.setErrors('reset');

        document.querySelector('#saveAll i').setAttribute('data-icon-after', 'cloud_queue');
        document.querySelector('#saveAll').classList.add('saving');

        for (let item of document.querySelectorAll('.editable .saveInput')) {
            item.setAttribute('data-icon-after', 'cloud_queue');
            id = item.parentNode.querySelector('input').getAttribute('data-id');
            value = item.parentNode.querySelector('input').getAttribute('value');
            if (item.parentNode.querySelector('input').classList.contains('changed')) {
                if (value.trim() === '') {
                    value = '0';
                }
                saveObject.push({
                    Id: id,
                    Value: value,
                });

                item.parentNode.querySelector('input').classList.remove('changed');
            }
        }
        await this.saveDataAsync({ event: evt, save: saveObject, mode: 'all' });
    };

    /**
     * @description Save data from input/inputs
     * @param {Object} evt event
     * @returns void
     */
    prepareSaveInput = async (evt) => {
        let id, value;

        this.setErrors('reset');

        evt.target.setAttribute('data-icon-after', 'cloud_queue');
        id = evt.target.parentNode.querySelector('input').getAttribute('data-id');
        value = evt.target.parentNode.querySelector('input').getAttribute('value');
        if (value.trim() === '') {
            value = '0';
        }
        evt.target.parentNode.querySelector('input').classList.remove('changed');
        await this.saveDataAsync({
            event: evt,
            save: { Id: id, Value: value },
            mode: 'single',
        });
    };

    /**
     * @description Set error state for save buttons
     * @param {*} errorState
     */
    setErrors = (errorState) => {
        if (errorState === 'set') {

            document.querySelector('#saveAll').classList.remove('saving');
            document.querySelector('#saveAll i').setAttribute('data-icon-after', 'save');
            document.querySelector('#saveAll span').innerText = window.discountTranslate.saveAll;
            document.querySelector('#saveAll').classList.add('hidden');

            for (let item of document.querySelectorAll('.editable .saveInput')) {
                item.setAttribute('data-icon-after', 'error');
            }
        }

        if (errorState === 'reset') {
            document.querySelector('#saveAll i').setAttribute('data-icon-after', 'save');
            document.querySelector('#saveAll').classList.remove('error');
            document.querySelector('#saveAll span').innerText = window.discountTranslate.saveAll;
        }

    };

    /**
     * @description Posting data to backend & handling response object
     * @requires module:Table class
     * @param {Object} params evt: event, save: {Id, Value}, mode: single || all
     */
    saveDataAsync = async (params) => {

        const response = await this.repository.postDataAsync({
            route:
                params.mode === 'single'
                    ? this.eventProps.saveSingleRoute
                    : this.eventProps.saveAllRoute,
            payload: params.save,
        });

        if (typeof response === 'object') {
            let moreChangesExist = false;

            for (let item of document.querySelectorAll('.editable .saveInput')) {
                if (item.parentNode.querySelector('input').classList.contains('changed')) {
                    moreChangesExist = true;
                }
            }

            if(!moreChangesExist) {
                document.querySelector('#saveAll').classList.remove('saving');
                document.querySelector('#saveAll i').setAttribute('data-icon-after', 'save');
                document.querySelector('#saveAll span').innerText = window.discountTranslate.saveAll;
                document.querySelector('#saveAll').classList.add('hidden');
            }


            this.tableElements.restoreElements({
                element: params.event,
                mode: params.mode,
                response: response,
            });

            this.table.updateTableCells(response, this.tableProps);
        } else {
            console.log(response);
            this.setErrors('set');
        }
    };
}